import { render } from "./people.vue?vue&type=template&id=cec0f53c"
import script from "./people.js?vue&type=script&lang=js&external"
export * from "./people.js?vue&type=script&lang=js&external"

import "./people.vue?vue&type=style&index=0&id=cec0f53c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__